import React from 'react';
import PropTypes from 'prop-types';
import moment from 'moment-timezone';
import TimeDisplay from 'components/TimeDisplay';

const Destination = ({
  time_from,
  time_to,
  label,
  country,
  time_from_tz,
  time_to_tz,
  test_id
}) => {
  return (
    <div
      className="destinations-side__localization"
      data-testid={`destinations-side__destination-${test_id}`}
    >
      <div className="destinations-side__icon-container">
        <div className="destinations-side__icon" />
      </div>
      <div className="destinations-side__body">
        <div className="destinations-side__date">
          {moment(time_from)
            .tz(time_from_tz)
            .format('D MMM')}
        </div>
        <div className="destinations-side__time">
          <TimeDisplay
            time_from={time_from}
            time_to={time_to}
            time_from_tz={time_from_tz}
            time_to_tz={time_to_tz}
          />
        </div>
        <div className="destinations-side__location">{`${label} ${country}`}</div>
      </div>
    </div>
  );
};

const DestinationsSide = ({
  className,
  start_time_from,
  start_time_to,
  label_from,
  country_from,
  end_time_from,
  end_time_to,
  label_to,
  country_to,
  start_time_from_tz,
  start_time_to_tz,
  end_time_from_tz,
  end_time_to_tz
}) => {
  return (
    <div className={className} data-testid="destinations-side">
      <div className="destinations-side">
        <Destination
          time_from={start_time_from}
          time_to={start_time_to}
          time_from_tz={start_time_from_tz}
          time_to_tz={start_time_to_tz}
          label={label_from}
          country={country_from}
          test_id={1}
        />
        <Destination
          time_from={end_time_from}
          time_to={end_time_to}
          time_from_tz={end_time_from_tz}
          time_to_tz={end_time_to_tz}
          label={label_to}
          country={country_to}
          test_id={2}
        />
      </div>
    </div>
  );
};

DestinationsSide.defaultProps = {
  country_from: '',
  country_to: ''
};

DestinationsSide.propTypes = {
  start_time_from: PropTypes.string.isRequired,
  start_time_to: PropTypes.string.isRequired,
  label_from: PropTypes.string.isRequired,
  country_from: PropTypes.string.isRequired,
  end_time_from: PropTypes.string.isRequired,
  end_time_to: PropTypes.string.isRequired,
  label_to: PropTypes.string.isRequired,
  country_to: PropTypes.string.isRequired,
  start_time_from_tz: PropTypes.string.isRequired,
  start_time_to_tz: PropTypes.string.isRequired,
  end_time_from_tz: PropTypes.string.isRequired,
  end_time_to_tz: PropTypes.string.isRequired
};

export default DestinationsSide;
